import React from 'react';
import { Navbar } from './components/Navbar';
import { Hero } from './components/Hero';
import { Problems } from './components/Problems';
import { JerseyBuilder } from './components/JerseyBuilder';
import { RosterCards } from './components/RosterCards';
import { TournamentBracket } from './components/TournamentBracket';
import { Pricing } from './components/Pricing';
import { Footer } from './components/Footer';
export function App() {
  return <div className="bg-gray-950 text-white min-h-screen" data-id="element-0">
      <Navbar data-id="element-1" />
      <Hero data-id="element-2" />
      <Problems data-id="element-3" />
      <JerseyBuilder data-id="element-4" />
      <RosterCards data-id="element-5" />
      <TournamentBracket data-id="element-6" />
      <Pricing data-id="element-7" />
      <Footer data-id="element-8" />
    </div>;
}